
    <h1 mat-dialog-title>
      <i class="fas fa-exclamation-triangle mr-3"></i>
      {{data?.title || 'Please confirm your action'}}
    </h1>
    <div mat-dialog-content>
      <mat-list class="mat-dialog-data-list">
          <h3 mat-subheader>{{data?.subtitle || 'Are you sure?'}}</h3>
          <mat-list-item>
            <textarea [readonly]="dialogData.readOnly" placeholder="{{dialogData.placeholder || 'Enter comment here'}}" matInput [(ngModel)]="dialogData.comment" style="min-height: 150px "></textarea>
          </mat-list-item>
      </mat-list>
    </div>
    <div mat-dialog-actions class="justify-content-center">
	    <button mat-raised-button mat-dialog-close cdkFocusInitial [mat-dialog-close]="false">Cancel</button>
        <button [disabled]="dialogData.commentRequired && dialogData.comment.length === 0" (click)="confirm()" mat-raised-button color="warn">{{dialogData.confirmBtnText || 'Yes, delete!'}}</button>
    </div>
  